<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="df-label" v-html="schema.label" />
</template>
<script>
import { PropsMixin } from '../mixins';
export default {
  mixins: [PropsMixin],
};
</script>
<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

$color-blackhole: map.get(colors.$baseColors, blackhole);

.df-label {
  @include global.p-large-semibold();
  margin-top: 2em;
  margin-bottom: 0.5em;
  color: $color-blackhole;
}
</style>
